<template>
  <form @submit="onFormSubmit">
    <TextInputFormField
      label="Phone Number"
      class="mb-4"
      name="sms"
      type="tel"
    />
    <ActionButtonPrimary
      type="submit"
      :is-loading="isSubmitting"
      class="w-full"
    >
      Send Receipt
    </ActionButtonPrimary>
  </form>
</template>

<script setup lang="ts">
import { useForm } from "vee-validate"
import { toTypedSchema } from "@vee-validate/zod"
import { sendOrderReceipt } from "@/services/orders/sendOrderReceipt"
import { sendTransactionReceipt } from "@/services/transactions/sendTransactionReceipt"
import z from "zod"
import { ApiError } from "@/services/api"
import { requiredTrimmedString } from "@/forms/validation/stringFieldSchemas"

const props = defineProps<{
  objectId: string
  receiptType: "order" | "transaction"
}>()

const emit = defineEmits<{
  (eventName: "submit-success"): void
}>()

const formSchema = z.object({
  sms: requiredTrimmedString("Please enter a phone number"),
})

const { handleSubmit, isSubmitting, setFieldError } =
  useForm({
    validationSchema: toTypedSchema(formSchema),
    initialValues: { sms: "" },
  })

const onFormSubmit = handleSubmit(async (formValues) => {
  try {
    props.receiptType === "order"
      ? await sendOrderReceipt(props.objectId, formValues)
      : await sendTransactionReceipt(
          props.objectId,
          formValues
        )
    toast.success(`Receipt sent to ${formValues.sms}`)
    emit("submit-success")
  } catch (error) {
    if (error instanceof ApiError) {
      const smsValidationError =
        error?.requestErrors?.body?.sms

      if (smsValidationError) {
        setFieldError("sms", smsValidationError)
        return
      }
      if (error.code === "sms-service-disabled") {
        toast.error("SMS service is disabled")
      } else {
        toast.error("Failed to send receipt")
      }
    } else {
      toast.error("Failed to send receipt")
    }
  }
})
</script>
